import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { ResponsiveService } from '../../../services/responsive.service';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { ApiQuery } from '../../../web-services/api/api.query';
import { FilteredSamples } from './filtered-samples/filtered-samples';
import { UnfilteredSamples } from './unfiltered-samples/unfiltered-samples';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-bin-capacity',
  imports: [CommonModule,TranslatePipe,RTLDivDirectiveDirective,FilteredSamples,UnfilteredSamples,
    FormsModule,MatDividerModule],  
  templateUrl: './bin-capacity.html',
  styleUrl: './bin-capacity.scss',
})
export class BinCapacity {
  isMobile: Boolean;
	@Input() binLiveInfo_Bin; 		
	@Output() rangeBtnEvent = new EventEmitter<boolean>();
  isUnfilteredTransmission:boolean = false;
	user_role_id = 0;

	constructor(private responsiveService: ResponsiveService,private apiQuery:ApiQuery) {}

	ngOnInit() {
    this.onResize();
    this.responsiveService.checkWidth();
    this.apiQuery.user$.subscribe(user => {
			if (!user) return;
      this.user_role_id = user["user_role_id"];
		});
	}

  onResize() {
    this.responsiveService.getMobileStatus().subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  rangeBtnEventHander($event: any) {
    this.rangeBtnEvent.emit($event);
	}

  unfilteredTransmissionBtn(value){
    this.isUnfilteredTransmission = value;
  }
}
